export default __webpack_public_path__ + "static/media/pol2l.7f1bc04c.svg";